// extracted by mini-css-extract-plugin
module.exports = {"button":"badge-picker-button_button__Ozmcr","badge":"badge-picker-button_badge__maz__","popover":"badge-picker-button_popover__LagdP"};